import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Carousel from "shared/components/carousel/Carousel";
import styles from "./CampaignMedia.module.css";

const CampaignMedia = ({ campaign }) => {
  const [campaignMedia, setCampaignMedia] = useState([]);

  useEffect(() => {
    const campaignVids = (campaign.campaign_videos || []).map((vid) => {
      return { type: "video", value: vid.name, position: vid.position };
    });
    const campaignImgs = (campaign.campaign_images || []).map((img) => {
      return { type: "image", value: img.name.url || img.name, position: img.position };
    });

    setCampaignMedia(
      campaignVids.concat(campaignImgs).sort((a, b) => a.position - b.position),
    );
  }, [campaign.campaign_videos, campaign.campaign_images]);

  return (
    <div className={styles.campaignMediaWrapper}>
      {campaignMedia.length > 0 && (
        <Carousel urlList={campaignMedia} isAutoPlay={campaign.auto_media_carousel} />
      )}
    </div>
  );
};

CampaignMedia.propTypes = {
  campaign: PropTypes.object.isRequired,
};

export default CampaignMedia;
